<template>
  <div class="event animate__animated animate__fadeIn">
    <img class="event-image" :src="imgPath" alt="event-image">
    <div class="event-text">
      <div class="event-title-wrapper">
        <router-link :to="'/event/' + id" class="event-title">
          {{ title }}
        </router-link>
        <div class="event-details">
          {{ getDateFromString }} в {{ getTimeFromString }}
        </div>
      </div>
      <div class="event-description">
        {{ description }}
      </div>
      <div class="event-button-wrapper">
        <div class="event-price" v-if="!price">
          Бронирование
        </div>
        <div class="event-price" v-if="price !== 0 && price !== undefined">
          Вход - {{ price + getCurrency }}
        </div>
        <div class="event-price" v-if="price === 0">
          Бесплатно
        </div>
        <custom-button
          v-if="!hallType"
          buttonType="apply"
          :isBlocked="false"
          buttonText="Регистрация"
          @clicked="openEventBooking"/>

        <router-link class="link-to-book" :to="'event-hall/' + id">
          <custom-button
            v-if="hallType"
            buttonType="apply"
            :isBlocked="false"
            buttonText='Бронирование'
          >
          </custom-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from './Inputs/CustomButton.vue'
import moment from 'moment/moment'
import {EventBus} from '@/eventBus'

export default {
  name: 'event',
  components: {CustomButton},
  props: ['id', 'title', 'dateStart', 'description', 'price', 'imgPath', 'hallType'],
  computed: {
    getDateFromString () {
      return moment(this.dateStart, 'YYYY-MM-DD HH:mm').locale('ru').format('DD MMM yyyy')
    },
    getTimeFromString () {
      return moment(this.dateStart, 'YYYY-MM-DD HH:mm').format('HH:mm')
    },
    getCurrency() {
      return this.$store.state.adminProperties && this.$store.state.adminProperties.currency ? this.$store.state.adminProperties.currency.symbol : ""
    }
  },
  methods: {
    openEventBooking () {
      let data = {
        bookingType: 'EVENT',
        bookingData: {
          id: this.id,
          title: this.title,
          dateStart: this.dateStart,
          price: this.price
        }
      }

      EventBus.$emit('openForm', data)
    }
  }
}
</script>

<style scoped>
  .event {
    display: flex;
    flex-direction: row;
    border-radius: 12px;
    border: 1px solid #D0D5DD;
    background: #FFF;
    box-shadow: 0 8px 8px -4px rgba(16, 24, 40, 0.03), 0 20px 24px -4px rgba(16, 24, 40, 0.08);
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    width: 80%;
    max-height: 300px;
    transition: .2s;
  }

  .event-image {
    height: 100%;
    border-radius: 12px 0 0 12px;
    width: 17%;
  }

  .link-to-book {
    display: contents;
  }

  .event-text {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px 24px 24px 60px;
    width: 100%;
  }

  .event-title-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .event-title {
    color: #101828;
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
  }

  .event-details {
    color: #101828;
    font-size: 14px;
    font-weight: 300;
    line-height: 28px; /* 200% */
  }

  .event-description {
    color: #101828;
    text-overflow: ellipsis;
    font-size: 12px;
    flex-grow: 1;
    font-weight: 400;
  }

  .event-button-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    height: 35px;
  }

  .event-price {
    width: 100%;
    color: #344054;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
  }
</style>



// WEBPACK FOOTER //
// src/components/client/Event.vue